export const APP_VERSION: string = process.env.REACT_APP_VERSION || '';
export const PREFIX: string = '/api';
export const MAX_SIZE_AVATAR: number = 100000;
export const MAX_SIZE_LOGO: number = 1000000;
export const AVATAR_WIDTH: number = 480;
export const AVATAR_HEIGHT: number = 640;
export const USER_ROLES = ['', 'Администратор', 'Сотрудник', 'Студент', 'Контрагент'];
export const CAMPUS_DIGITS = 11;